import { useEffect, useState } from 'react';
import { Outlet, useLocation, useParams } from 'react-router';
import { Sidebar } from '../components/Sidebar';
import { Topbar } from '../components/Topbar';

export function AppShell() {
  const { eventId } = useParams();
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  // Auto-close the mobile drawer on any navigation. (No-op on desktop where
  // the sidebar is permanently visible.)
  useEffect(() => {
    setSidebarOpen(false);
  }, [location.pathname]);

  return (
    <div className="app">
      <Topbar onMenuClick={() => setSidebarOpen(true)} />
      <Sidebar
        eventId={eventId}
        open={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
      />
      {sidebarOpen && (
        <div
          className="sidebar-scrim"
          onClick={() => setSidebarOpen(false)}
          aria-hidden="true"
        />
      )}
      <div className="main">
        <Outlet />
      </div>
    </div>
  );
}
